var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VIEWBUTTONS d-flex"},[_c('router-link',{attrs:{"target":[_vm.$device.isMobileOrTablet ? '_self' : '_blank'],"to":{
        name: 'pro-public-profile',
        params: { serviceProviderOccupationId: _vm.publicProfileId }
  }}},[_c('span',{staticClass:"VIEWPROFILE btn-secondary btn-sm m-l-auto m-r-0"},[_c('a',{staticClass:"VIEWPROFILETEXT"},[_vm._v("\n        View Profile\n      ")])])]),_c('span',{on:{"click":function($event){return _vm.$emit('showInfoModal')}}},[_c('a',{staticClass:"VIEWPROFILETEXT m-l-2"},[_vm._v("\n      View Reviews\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }